import { render, staticRenderFns } from "./serverManage.vue?vue&type=template&id=23e90322&scoped=true"
import script from "./serverManage.vue?vue&type=script&lang=js"
export * from "./serverManage.vue?vue&type=script&lang=js"
import style0 from "./serverManage.vue?vue&type=style&index=0&id=23e90322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e90322",
  null
  
)

export default component.exports